import React from "react";
import CartList from "../components/Cart/CartList";

export const Cart = ({ cart, loading, get_delivery, delivery, total }) => {
  return (
    <>
      <CartList cart={cart} loading={loading} get_delivery={get_delivery} delivery={delivery} total={total} />
    </>
  );
};

export { Cart as default };
